<template>

    <div class="product">
        <div :id="product.Id" data-p-type="2" class="ih-item square effect6 from_top_and_bottom " >
            <router-link :to="{ name: 'view-product', params: { id: product.Id, name: deflate(product.Title) } }">
                <div class="img">
                        <img :src="product.PrimaryImage.Url" alt="">
                    </div> 
                    <div class="info f-f-jf-flat"> 
                        <h3>{{product.Title}}</h3>
                        <!-- <p>{{product.section.NameAr}}</p>  -->
                    </div> 
                </router-link>
            </div>
    </div>
 
</template>


<script>
export default {
  props: ['product'],
}
</script>

<style lang="scss">
@import "src/assets/sass/shared.scss";
    .ih-item {
 position:relative;
 @include transition(all 0.35s ease-in-out);
  & *{
      @include box-sizing(border-box);
  }
    &.square{
         position: relative;
          border:3px solid #fff;
          box-shadow:1px 1px 3px rgba(0,0,0,0.3);
            &.effect6 {
                
             overflow:hidden;

                .img{
                    @include transition(all 0.35s ease-in-out);
                    @include transform(scale(1));
                     @include aspect-ratio(4,3);

                    position: relative;
                     img{
                         position: absolute;
                         top:0px;
                         left: 0px;
                         height:100%;
                         width:100%;
                         object-fit: cover;
                     }
                }
                .info{
                   background:rgba(0,0,0,0.6);
                    visibility:hidden;
                    opacity:0;
                   @include transition(all 0.35s ease-in-out);

                   h3{
                       text-transform:uppercase;
                        color:#fff;
                        text-align:center;
                        font-size:17px;
                        padding:10px;
                        background:#111111;
                        margin:30px 0 0 0;
                        @include transition(all 0.35s ease-in-out);
                   }
                   p{
                       font-style:italic;
                        font-size:12px;
                        position:relative;
                        color:#bbb;
                        padding:20px 20px 20px;
                        text-align:center;
                        @include transition(all 0.35s 0.1s linear);
                   }
                }
                a{
                    &:hover .img{
                     @include transform(scale(1.2));   
                    }
                    &:hover .info{
                         visibility:visible;
                         opacity:1;
                    }
                    &:hover .info p{
                        @include transform(translateY(0%));
                        color :$main-color;
                    }
                    &:hover .info h3{
                        @include transform(translateY(0%));
                    }
                }
                &.from_top_and_bottom .info
                {
                    h3
                    {
                         @include  transform(translateY(-100%));
                    }
                    p{
                        @include  transform(translateY(100%));
                    }
                    a{
                        &:hover .info h3 , &:hover .info p{
                                @include transform(translateY(0));
                        }
                    }
                } 
            }
         img{
             width:100%;
         }

         & > a{
                
              .info{
                   position:absolute;
                    top:0;
                    bottom:0;
                    left:0;
                    right:0;
                    text-align:center;
                    -webkit-backface-visibility:hidden;
                    backface-visibility:hidden;
                    width: 100%;
                    margin: 0px auto;
              }
         }
    }
  a{
      color:#333;
      &:hover{
        text-decoration:none;
      }
  }
  img{
    width:100%;
    height:100%;
  }
}
@media(max-width:480px){
    .product{
        margin-top:15px;
    }
}

</style>




// WEBPACK FOOTER //
// src/components/products/product.vue